module.exports = __webpack_public_path__ + "img/oneList1.07228d92.png";